export function removeEndingSlash(string?: any): any {
  return (string ?? '').replace(/\/$/, '')
}
